import { render, staticRenderFns } from "./ComposeMessageForm.vue?vue&type=template&id=24576ea4&"
import script from "./ComposeMessageForm.vue?vue&type=script&lang=js&"
export * from "./ComposeMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./ComposeMessageForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports